import { useEffect, useRef } from 'react';
/**
 * Delay callback execution until the specified throttled delay time has elapsed
 *
 * @param {T} value The value to throttle
 * @param {(value: T) => void} callback The callback function to execute with the new throttled value
 * @param {number} delay The number of milliseconds where the value changed before updating the throttled value
 * @example
 * const [text, setText] = useState('Hello world!');
 * const [throttled, setThrottled] = useState('');
 * useThrottle(text, value => alert('Throttled value => ' + value), 1000);
 *
 * return (
 *   <>
 *     <input value={text} onChange={e => setText(e.target.value)} />
 *     <p>Actual value: {text}</p>
 *     <p>Throttled value: {throttled}</p>
 *   </>
 * );
 */
export var useThrottle = function (value, callback, delay) {
    var lastRan = useRef(Date.now());
    useEffect(function () {
        var timeout = setTimeout(function () {
            if (Date.now() - lastRan.current >= delay) {
                lastRan.current = Date.now();
                // Throttle time has passed, emit new value
                callback(value);
            }
        }, delay - (Date.now() - lastRan.current));
        return function () { return clearTimeout(timeout); };
    }, [callback, delay, value]);
};
